let themeChartHashMap;
themeChartHashMap = {
    'dark': {
        "animation": "1",
        "basefontcolor": "#C5E7E2",
        "outcnvbasefontcolor":"#909bad",
        "basefont": "Montserrat",
        "baseFontSize": "13",
        "outCnvBaseFontSize": "12",
        "showborder": "0",
        "bgcolor": "#1B2026",
        "bgalpha": "100",
        "showshadow": "0",
        "canvasbgcolor": "#1B2026",
        "showcanvasborder": "0",
        "useplotgradientcolor": "0",
        "useroundedges": "0",
        "showplotborder": "0",
        "showalternatehgridcolor": "0",
        "showalternatevgridcolor": "0",
        "tooltipcolor": "#909bad",
        "tooltipborderthickness": "0",
        "tooltipbgcolor": "#000000",
        "tooltipbgalpha": "75",
        "tooltipborderradius": "2",
        "tooltippadding": "15",
        "legendbgalpha": "0",
        "legendborderalpha": "0",
        "tooltipFontSize":"16",
        "legendshadow": "0",
        "legenditemfontsize": "10",
        "legenditemfontcolor": "#666666",
        "legendcaptionfontsize": "9",
        "divlinealpha": "0",
        "vdivlinealpha": "0",
        "divlinecolor": "#BEB2C8",
        "divlinethickness": "1",
        "scrollheight": "10",
        "flatscrollbars": "1",
        "scrollshowbuttons": "0",
        "scrollcolor": "#cccccc",
        "showhovereffect": "1",
        "showxaxisline": "1",
        "showyaxisline": "1",
        "xaxislinethickness": "1",
        "xaxislinecolor": "#BEB2C8",
        "yaxislinecolor": "#BEB2C8",
        "xaxisnamefontcolor": "#909BAD",
        "yaxisnamefontcolor": "#909BAD",
        "plotfillalpha": "100",
        "yAxisNamePadding":"20",
        "xAxisNamePadding":"20",
        "chartBottomMargin":"30",
        "chartLeftMargin":"30",
        "chartRightMargin":"30",
        "chartTopMargin":"30",
        "valuefontsize":"12",
        "labelfontsize":"12"
    }
}
export default themeChartHashMap;


// WEBPACK FOOTER //
// ./src/util/extraUtil/commonChartAttObj.js